import useSWR from 'swr'
import fetchDataService from '../services/fetchDataService'
import { generateFrontKeys } from '../services/securityService'
import { useCallback } from 'react'

function useLoadBase(token: any, session: any) {
  const config = {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshWhenOffline: false,
    refreshWhenHidden: false,
  }
  
  const fetcher = () => fetchDataService.post('/auth/me', token.key, { session })  
  const { data, error } = useSWR(() => token ? '/auth/me' : null, fetcher, config)

  return {
    data,
    error
  }
}

function useToken(typeToken: any, session: any, serverKey: any) {
  const frontKeyFetcher = async () => {
    await generateFrontKeys()
    const key = localStorage.getItem('frontKey')
    return { key }
  }
  const { data: frontKey } = useSWR('generatefrontkeys', frontKeyFetcher)

  const serverKeyFetcher = () => fetchDataService.post('/public/key', null, {})
  const tokenFetcher = (args: any) => fetchDataService.post(args[0], args[1], {
    typeToken,
    timeToken: 30,
    session
  }) 
  
  const config = {
    revalidateIfStale: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: false,
    refreshWhenOffline: false,
    refreshWhenHidden: false,
    dedupingInterval: 60000
  }
  const callToServerKey = frontKey && !serverKey
  const { data: keyData, mutate: mutateKeyData } = useSWR(() => callToServerKey ? '/public/key' : null, serverKeyFetcher, config)
  const dataToInitServer = keyData ? keyData.data : serverKey
  const { data: tokenData, mutate: mutateTokenData } = useSWR(() => dataToInitServer ? ['/security/auth/create-authsession', dataToInitServer] : null,
    tokenFetcher,
    config
  )
  if (tokenData && (tokenData.status === 401 || tokenData.status === 403 || tokenData.redirect)) {
    const targetUrl = tokenData.redirect || '/login'
    console.log("redireccionando a:", targetUrl)
    const redirect = btoa(window.location.href)
    window.location.href = targetUrl + (targetUrl.includes('?') ? '&' : '?') + "redirect=" + redirect
  }

  const resetState = useCallback(() => {
    mutateKeyData(undefined, { revalidate: true });
    mutateTokenData(undefined, { revalidate: true });
  }, [mutateKeyData, mutateTokenData]);

  return {
    tokenData,
    resetState
  }
}

const Auth = {
  useLoadBase,
  useToken
}

export default Auth
